import React, { useContext } from "react";
import { Context } from "../../context/Context";

// Shown instead of a branch page for a `branch` user who has no valid assigned
// branch (NA-035): an explanation, not a redirect and not an empty page.
const TEXT = {
  en: {
    title: "No branch is assigned to your account",
    body: "This page works with the branch assigned to you. Ask your administrator to assign a branch to your account, then reload.",
  },
  ar: {
    title: "لا يوجد فرع مرتبط بحسابك",
    body: "تعمل هذه الصفحة مع الفرع المرتبط بحسابك. اطلب من المسؤول ربط حسابك بفرع ثم أعد تحميل الصفحة.",
  },
};

export function BranchAssignmentRequired() {
  const { lang } = useContext(Context) || {};
  const text = TEXT[lang] || TEXT.ar;
  return (
    <div
      role="alert"
      dir={lang === "en" ? "ltr" : "rtl"}
      data-testid="branch-assignment-required"
      style={{ padding: 24, maxWidth: 560 }}
    >
      <h2 style={{ marginTop: 0 }}>{text.title}</h2>
      <p>{text.body}</p>
    </div>
  );
}

export default BranchAssignmentRequired;
